module.exports = __webpack_public_path__ + "static/original-mobile-3bef838f910e4da88fcf556bf7f05021.jpg";